import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import promoConfig from '../config/promoConfig.json';

/**
 * Hook para gestionar el filtrado de productos por promocion.
 * Lee el query param 'promo' de la URL y filtra productos segun la configuracion.
 *
 * @param {Array} products - Lista de productos a filtrar
 * @returns {Object} - { filteredProducts, activePromo, isPromoFilterActive, clearPromoFilter }
 */
export const usePromoFilter = (products) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const promoId = searchParams.get('promo');

    const activePromo = useMemo(() => {
        if (!promoId) return null;

        if (promoConfig.id !== promoId) return null;

        if (!promoConfig.enabled) return null;

        if (!promoConfig.productPrefix) return null;

        return {
            id: promoConfig.id,
            productPrefix: promoConfig.productPrefix,
            title: promoConfig.content?.title || 'Promocion Especial'
        };
    }, [promoId]);

    const filteredProducts = useMemo(() => {
        if (!activePromo) return products;

        return products.filter(product =>
            product.id.startsWith(activePromo.productPrefix)
        );
    }, [products, activePromo]);

    const clearPromoFilter = () => {
        searchParams.delete('promo');
        setSearchParams(searchParams);
    };

    return {
        filteredProducts,
        activePromo,
        isPromoFilterActive: !!activePromo,
        clearPromoFilter
    };
};

export default usePromoFilter;
